import React from 'react';
import MobileNav from '@components/Quoting/MobileNav/MobileNav';
import TextBox from '@components/TextBox/TextBox';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const thankYou = props => {
  const { isMobile } = props;
  return (
    <React.Fragment>
      {isMobile && <MobileNav {...this.props} title={'Thank You'} />}
      <TextBox header={isMobile ? false : 'Thank You'}>
        {/* TOP SUMMARY BOX */}
        <div className={'position-relative mb-3 font-sm asap-medium'}>
          Thank you for requesting a trip with JetSuite! We will send your
          confirmed itinerary and all other flight details shortly.
          <br />
          <br />
          If you have any questions, please call{' '}
          <a href="tel:+18775199759" className={'asap-bold red-link'}>
            (877) 519-9759
          </a>
          .
        </div>
      </TextBox>

      {!isMobile && (
        <button
          className="btn btn-transparent mt-2 float-left"
          onClick={props.prevClick}
        >
          <strong>
            <FontAwesomeIcon icon={['fas', 'chevron-left']} />
            &nbsp;&nbsp;Back to My Account
          </strong>
        </button>
      )}
      <div className={'clearfix'} style={{ clear: 'both' }} />
    </React.Fragment>
  );
};

export default thankYou;



// WEBPACK FOOTER //
// ./src/components/Quoting/Board/ThankYou/ThankYou.jsx